<template>
  <div>
    <b-modal
      id="select-customer-modal"
      no-close-on-backdrop
      hide-footer
      size="xl"
      body-class="p-0 customer-modal-wrapper"
      style="height: 90vh"
      no-fade
      @shown="onModalShown"
      @hide="onModalHide"
      @hidden="onModalHidden"
    >
      <template
        slot="modal-header"
        slot-scope="{ close }"
      >
        <div class="d-md-none d-flex align-items-center justify-content-between w-100 px-3">
          <b-button
            variant="outline-light"
            @click="close()"
          >
            {{ $t("customerlistpopup.cancel") }}
          </b-button>
          <h5 class="mb-0">
            {{ $t("customerlistpopup.select-customer") }}
          </h5>
          <svg
            class="icon icon-icon-plus"
            @click="showAddCustomerModal"
          >
            <use xlink:href="#icon-icon-plus" />
          </svg>
        </div>
        <div class="d-none d-md-flex align-items-center justify-content-between w-100 px-3">
          <div>
            <b-button
              variant="outline-light"
              @click="close()"
            >
              {{ $t("customerlistpopup.cancel") }}
            </b-button>
          </div>
          <h5 class="mb-0">
            {{ $t("customerlistpopup.select-customer") }}
          </h5>
          <div>
            <b-button
              variant="primary"
              @click="showAddCustomerModal"
            >
              {{ $t("customerlistpopup.add") }}
            </b-button>
          </div>
        </div>
      </template>
      <div class="select-tabs">
        <button
          type="button"
          class="select-tabs__tab"
          :class="{ 'select-tabs__tab--active': activeTab === 'customers' }"
          @click="activeTab = 'customers'"
        >
          Customers
        </button>
        <button
          type="button"
          class="select-tabs__tab"
          :class="{ 'select-tabs__tab--active': activeTab === 'employees' }"
          @click="activeTab = 'employees'"
        >
          Employees
        </button>
      </div>
      <template v-if="activeTab === 'customers'">
        <div class="search">
          <label
            class="search__icon-label"
            for="search-customer-input"
          >
            <svg class="icon icon-icon-search">
              <use xlink:href="#icon-icon-search" />
            </svg>
          </label>
          <b-input
            id="search-customer-input"
            ref="searchField"
            v-model="search"
            :placeholder="$t('searchbar.search-item')"
            class="search__customer-input"
            autocomplete="off"
          />
        </div>
        <div class="table-header">
          <div class="text-left">
            <span>Name</span>
          </div>
          <div class="text-right">
            <span class="phone-number">Phone Number</span>
            <span class="actions-space" />
          </div>
        </div>
        <div
          class="content"
          @scroll="handleScroll($event)"
        >
          <div
            v-for="customer in filteredCustomers"
            :key="customer.id"
            class="orders-bottom-item"
          >
            <div class="text-left">
              <span>
                {{ customerFullName(customer) }}
              </span>
            </div>
            <div class="text-right">
              <span class="px-2">
                {{ customer.phone }}
              </span>
              <div class="button-group">
                <div class="d-md-none d-flex">
                  <svg
                    class="margin-r icon icon-icon-view"
                    @click="showViewCustomerModal(customer)"
                  >
                    <use xlink:href="#icon-icon-view" />
                  </svg>
                  <template v-if="selectedCustomer && customer.id === selectedCustomer.id">
                    <svg
                      class="margin-r icon icon-icon-fill-check"
                      @click="removeCustomer"
                    >
                      <use xlink:href="#icon-icon-fill-check" />
                    </svg>
                    <svg
                      class="icon icon-icon-edit"
                      @click="openAddNewAddressModal(customer)"
                    >
                      <use xlink:href="#icon-icon-edit" />
                    </svg>
                  </template>
                  <template v-else>
                    <svg
                      class="margin-r icon icon-icon-unfill-check"
                      @click="selectCustomer(customer)"
                    >
                      <use xlink:href="#icon-icon-unfill-check" />
                    </svg>
                    <svg
                      class="icon icon-icon-edit"
                      @click="openAddNewAddressModal(customer)"
                    >
                      <use xlink:href="#icon-icon-edit" />
                    </svg>
                  </template>
                </div>
                <div class="d-none d-md-block">
                  <b-button
                    variant="outline-light"
                    class="action-btn"
                    @click="showViewCustomerModal(customer)"
                  >
                    {{ $t("customerlistpopup.view-customer") }}
                  </b-button>
                  <template v-if="selectedCustomer && customer.id === selectedCustomer.id">
                    <b-button
                      variant="danger"
                      class="action-btn"
                      @click="removeCustomer"
                    >
                      {{ $t("customerlistpopup.remove-customer") }}
                    </b-button>
                    <b-button
                      variant="outline-light"
                      class="action-btn"
                      @click="openAddNewAddressModal(customer)"
                    >
                      Update Address
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button
                      variant="outline-light"
                      class="action-btn"
                      @click="selectCustomer(customer)"
                    >
                      {{ $t("customerlistpopup.apply-customer") }}
                    </b-button>
                    <b-button
                      variant="outline-light"
                      class="action-btn"
                      @click="openAddNewAddressModal(customer)"
                    >
                      Update Address
                    </b-button>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="search.length !== 0"
            class="orders-bottom-item orders-bottom-item__add-new"
            @click="showAddCustomerModal"
          >
            <span>
              Add New Customer
            </span>
          </div>
          <div
            v-if="isLoading"
            class="text-center py-3"
          >
            <b-spinner
              variant="primary"
              label="Loading..."
            />
          </div>
        </div>
      </template>
      <template v-else>
        <div class="search">
          <label
            class="search__icon-label"
            for="search-employee-input"
          >
            <svg class="icon icon-icon-search">
              <use xlink:href="#icon-icon-search" />
            </svg>
          </label>
          <b-input
            id="search-employee-input"
            v-model="employeeSearch"
            :placeholder="$t('searchbar.search-item')"
            class="search__customer-input"
            autocomplete="off"
          />
        </div>
        <div class="table-header">
          <div class="text-left">
            <span>Name</span>
          </div>
          <div class="text-right">
            <span class="phone-number">Role</span>
            <span class="actions-space" />
          </div>
        </div>
        <div class="content">
          <div
            v-for="emp in filteredEmployees"
            :key="emp.id"
            class="orders-bottom-item"
          >
            <div class="text-left">
              <span>{{ emp.name }}</span>
            </div>
            <div class="text-right">
              <span class="px-2 role-value">{{ emp.role_details ? emp.role_details.name : '' }}</span>
              <div class="button-group">
                <div class="d-none d-md-block">
                  <b-button
                    v-if="selectedEmployeeId === emp.id"
                    variant="danger"
                    class="action-btn"
                    @click="removeEmployee"
                  >
                    Remove
                  </b-button>
                  <b-button
                    v-else
                    variant="outline-light"
                    class="action-btn"
                    @click="selectEmployee(emp)"
                  >
                    Select
                  </b-button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="filteredEmployees.length === 0"
            class="text-center py-3"
          >
            <span>No employees found</span>
          </div>
        </div>
      </template>
      <CustomerModal
        :view-customer="viewCustomer"
        :is-selected="isSelectedViewCustomer"
        get-customers="getCustomers"
        @select-customer-after-add="selectCustomer"
        @select-customer="selectCustomer"
        @close-modal="clearViewCustomer"
      />
      <CustomerModalSimple
        get-customers="getCustomers"
        @select-customer-after-add="selectCustomer"
        @close-modal="clearViewCustomer"
      />
    </b-modal>
    <AddNewAddressModal
      :open="showUpdateAddAddressModal"
      :customer="updateAddressCustomer"
      @closeModal="closeAddNewAddressModal"
    />
  </div>
</template>

<script>
import viewCustomerModalMixin from "../mixins/modals/viewCustomerModalMixin";
import DashboardService from "../services/dashboard-service";
import indexDbService from "@/helpers/dbHelper";
import {debounce} from 'lodash';

export default {
  name: "SelectCustomerModal",
  components: {
    CustomerModal: () => import("./CustomerModal.vue"),
    CustomerModalSimple: () => import("./CustomerModalSimple.vue"),
    AddNewAddressModal: () => import("../modals/Address/AddNewAddressModal.vue")
  },
  mixins: [viewCustomerModalMixin],
  props: {
    orderCustomer: { type: Object, default: null },
    orderDiscountEmployee: { type: [Number, String], default: null },
    employees: { type: Array, default: () => [] }
  },
  data() {
    return {
      search: "",
      selectedCustomer: null,
      activeTab: "customers",
      employeeSearch: "",
      selectedEmployeeId: null,
      viewCustomer: null,
      showUpdateAddAddressModal: false,
      updateAddressCustomer: null,
      customersCache: [],
      customersLocal: [],
      page: 1,
      isLoading: false,
      loadingCount: 0,
      hasMore: true,
      nextPage: null,
      loadSessionId: 0,
      suppressSearchWatcher: false
    };
  },
  computed: {
    terminal() {
      return this.$store.getters["config/terminal"];
    },
    isAddCustomerDirect() {
      if (!this.terminal || !this.terminal.db_settings) return false;
      const setting = this.terminal.db_settings.find(s => s.name === 'add_customer_direct');
      return setting && setting.value === 'true';
    },
    customers() {
      return this.customersLocal;
    },
    isSearching() {
      return !!(this.search && this.search.trim().length);
    },
    isSelectedViewCustomer() {
      if (!this.viewCustomer || !this.selectedCustomer) return false;
      return this.viewCustomer.id === this.selectedCustomer.id;
    },
    filteredCustomers() {
      let filtered = [...this.customers]; // Create a copy of the array
      
      // Remove selected customer from the list if it exists
      if (this.selectedCustomer) {
        filtered = filtered.filter(c => c.id !== this.selectedCustomer.id);
      }
      
      // Add selected customer at the beginning if it exists
      if (this.selectedCustomer) {
        filtered.unshift(this.selectedCustomer);
      }
      
      return filtered;
    },
    filteredEmployees() {
      const term = this.employeeSearch.trim().toLowerCase();
      const list = this.employees || [];
      if (!term) return list;
      return list.filter((emp) => (emp.name || "").toLowerCase().includes(term));
    }
  },
  watch: {
    orderDiscountEmployee: {
      immediate: true,
      handler(id) {
        this.selectedEmployeeId = id || null;
      }
    },
    orderCustomer(customer) {
      this.selectedCustomer = customer;
    },
    search() {
      if (this.suppressSearchWatcher) return;
      this.debouncedSearch();
    }
  },
  beforeDestroy() {
    // Reset pagination when modal is destroyed
    this.page = 1;
    this.hasMore = true;
    this.nextPage = null;
    this.loadSessionId += 1;
  },
  mounted() {
    // Load customers when the modal is mounted
    // Check if we already have customers in the store, if not load them
    if (this.customersLocal.length === 0) {
      this.initCustomersOnOpen();
    }
  },
  methods: {
    onModalHide() {
      // Keep this handler minimal to avoid blocking modal close.
      // Cancel debounce and ignore any in-flight requests.
      try {
        if (this.debouncedSearch && this.debouncedSearch.cancel) {
          this.debouncedSearch.cancel();
        }
      } catch (e) {
        // ignore
      }

      this.loadSessionId += 1;
    },

    onModalHidden() {
      // Heavy cleanup AFTER the modal is already closed.
      this.loadingCount = 0;
      this.isLoading = false;

      // Clearing search can trigger debounce/network; suppress watcher during cleanup.
      this.suppressSearchWatcher = true;
      this.search = '';
      this.$nextTick(() => {
        this.suppressSearchWatcher = false;
      });
    },

    customersCacheTimestampKey() {
      const baseUrl = localStorage.getItem('baseUrl') || '';
      return `customers_cache_timestamp::${baseUrl}`;
    },

    isCustomersCacheValid() {
      const key = this.customersCacheTimestampKey();
      const raw = localStorage.getItem(key);
      if (!raw) return false;
      const ts = Number(raw);
      if (!ts) return false;
      const twelveHoursMs = 12 * 60 * 60 * 1000;
      return (Date.now() - ts) < twelveHoursMs;
    },

    setCustomersCacheTimestampNow() {
      const key = this.customersCacheTimestampKey();
      localStorage.setItem(key, String(Date.now()));
    },

    async loadCustomersFromCache() {
      const cached = await indexDbService.getDbData('customers');
      this.customersCache = Array.isArray(cached) ? cached : [];
      if (!this.isSearching) {
        this.customersLocal = [...this.customersCache];
      }
      return this.customersCache.length;
    },

    async initCustomersOnOpen() {
      this.page = 1;
      this.hasMore = true;
      this.nextPage = null;
      this.loadSessionId += 1;

      await this.loadCustomersFromCache();

      // Never call the customers list API when opening the modal.
      // The list should come from local IndexedDB cache.
      this.hasMore = false;
    },

    onModalShown() {
      // Set the selected customer from the prop when modal is shown
      this.selectedCustomer = this.orderCustomer;
      // Ensure customers are loaded when modal is shown
      this.initCustomersOnOpen();
    },
    getCustomers() {
      // Method to refresh customers list (used by child components)
      this.search = '';
      this.initCustomersOnOpen();
    },
    debouncedSearch: debounce(async function() {
      // If search is cleared, show cached list and do not call API
      if (!this.isSearching) {
        this.customersLocal = [...this.customersCache];
        this.page = 1;
        this.hasMore = false;
        this.nextPage = null;
        this.loadSessionId += 1;
        return;
      }

      // NOTE: no membership-scan auto-select here. On this screen a "MEM..." value
      // is treated as a normal search term so the user always picks the customer
      // themselves - the eos_memberscan auto search/create/select flow only runs
      // from the order search bar (StandardOrder.vue).

      // Reset pagination when searching
      this.page = 1;
      this.hasMore = true;
      this.nextPage = null;
      this.customersLocal = [];
      this.loadSessionId += 1;
      // For search, do not refetch all pages; fetch page 1 and then paginate on scroll if needed.
      this.loadCustomers(false);
    }, 500),
    async loadCustomers(loadAllPages = false) {
      // Do NOT block new searches/loads when network is slow.
      // Use loadSessionId to ignore stale responses instead.
      const sessionId = this.loadSessionId;
      this.loadingCount += 1;
      this.isLoading = this.loadingCount > 0;

      try {
        await this.loadCustomersPage(sessionId);

        if (loadAllPages) {
          while (this.loadSessionId === sessionId && this.hasMore && this.nextPage) {
            await this.loadCustomersPage(sessionId);
          }
        }
      } catch (error) {
        // Ignore errors from stale sessions (user typed again / cleared search)
        if (this.loadSessionId !== sessionId) {
          return;
        }

        console.error('Error loading customers:', error);
        this.$store.dispatch("errorModal/displayModalError", {
          modalId: "customer-error",
          errorBody: {
            title: "Error Loading Customers",
            info: "Failed to load customers. Please try again."
          }
        });
        this.hasMore = false;
      } finally {
        this.loadingCount = Math.max(0, this.loadingCount - 1);
        this.isLoading = this.loadingCount > 0;
      }
    },

    async loadCustomersPage(sessionId) {
      const commitPage = this.page;
      const response = this.nextPage
        ? await DashboardService.getNextCustomers(this.nextPage)
        : await DashboardService.getCustomersList({
          page: commitPage,
          search: this.isSearching ? (this.search || null) : null
        });

      if (this.loadSessionId !== sessionId) {
        return;
      }

      if (response.results && response.results.length > 0) {
        // Update local list with new customers
        response.results.forEach(retrieved => {
          const index = this.customersLocal.findIndex(item => item.id === retrieved.id);
          if (index === -1) {
            this.customersLocal.push(retrieved);
          } else {
            this.customersLocal[index] = { ...this.customersLocal[index], ...retrieved };
          }

          // Merge into cached list and persist
          const cacheIndex = this.customersCache.findIndex(item => item.id === retrieved.id);
          if (cacheIndex === -1) {
            this.customersCache.push(retrieved);
          } else {
            this.customersCache[cacheIndex] = { ...this.customersCache[cacheIndex], ...retrieved };
          }
          indexDbService.saveToDb('customers', retrieved).then();
        });

        // Searching should also refresh the cache freshness window since we updated cached rows
        this.setCustomersCacheTimestampNow();

        this.nextPage = response.next;
        // Always advance the page counter after a successful fetch so that
        // the store doesn't keep resetting the list (page === 1 resets).
        this.page = commitPage + 1;
        // Check if there are more pages
        this.hasMore = response.next !== null;
      } else {
        this.hasMore = false;
      }
    },
    handleScroll(e) {
      const element = e.target;
      if (element.scrollHeight - element.scrollTop <= element.clientHeight + 100 && this.hasMore) {
        // User has scrolled near the bottom (within 100px) and there are more customers to load
        this.loadCustomers(false);
      }
    },
    showAddCustomerModal() {
      // Hide the select modal first
      this.$bvModal.hide("select-customer-modal");
      
      // Then show the simplified modal
      this.$nextTick(() => {
        this.$bvModal.show("customer-modal-simple");
      });
    },
    customerFullName(customer) {
      return `${customer.first_name}${customer.last_name ? (" " + customer.last_name) : ""}`;
    },
    async selectCustomer(customer) {
      this.clearViewCustomer();
      // Ensure the select-customer modal is hidden
      this.$bvModal.hide("select-customer-modal");
      // Also hide the customer-modal-simple if it's open
      this.$bvModal.hide("customer-modal-simple");

      let selectedCustomer = customer;

      if (customer && customer.id) {
        try {
          const response = await DashboardService.getCustomerById(customer.id);

          // Handle either a single object response or {results: [...]} response.
          const latest = (response && Array.isArray(response.results))
            ? (response.results[0] || null)
            : response;

          if (latest && latest.id) {
            selectedCustomer = latest;

            // Persist the freshest server customer record locally.
            indexDbService.saveToDb('customers', latest).then()

            const cacheIndex = this.customersCache.findIndex(item => item.id === latest.id)
            if (cacheIndex === -1) {
              this.customersCache.push(latest)
            } else {
              this.customersCache[cacheIndex] = { ...this.customersCache[cacheIndex], ...latest }
            }

            const localIndex = this.customersLocal.findIndex(item => item.id === latest.id)
            if (localIndex !== -1) {
              this.customersLocal[localIndex] = { ...this.customersLocal[localIndex], ...latest }
            }

            this.setCustomersCacheTimestampNow();
          }
        } catch (e) {
          // ignore
        }
      }

      this.$emit("select-customer", selectedCustomer);
    },
    removeCustomer(customer) {
      this.$emit("remove-customer", customer);
    },
    selectEmployee(employee) {
      this.selectedEmployeeId = employee.id;
      this.$emit("select-employee", employee);
      this.$bvModal.hide("select-customer-modal");
    },
    removeEmployee() {
      this.selectedEmployeeId = null;
      this.$emit("remove-employee");
    },
    openAddNewAddressModal(customer=null){
      if(customer)
      {
      
        this.updateAddressCustomer = customer
        this.showUpdateAddAddressModal = true
      }

    },
    closeAddNewAddressModal(){
      this.showUpdateAddAddressModal = false
    }
  }
};
</script>

<style scoped lang="scss">
.customer-modal-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.margin-r {
  margin-right: 5px;
}

.role-value {
  text-transform: capitalize;
}

.select-tabs {
  display: flex;
  background: white;
  border-bottom: 1px solid #eee;
  padding: 0 1rem;
}

.select-tabs__tab {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 0.85rem 1rem;
  font-weight: 500;
  color: grey;
  cursor: pointer;

  &--active {
    color: #2196F3;
    border-bottom-color: #2196F3;
  }
}

.modal-body {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.search {
  position: relative;
  background: white;
}

.search__customer-input {
  background: none;
  border: none;
  padding-left: 40px;
  height: 3.5rem;
}

.search__icon-label {
  position: absolute;
  color: grey;
  left: 15px;
  top: 15px;
  margin: 0;
}

.orders-bottom-item {
  background: white;
  display: flex;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #eee;

  &__add-new {
    color: #2196F3;
  }

  .text-left {
    flex: 1;
    min-width: 0;
    word-break: break-word;
    padding-left: 1rem;
  }

  .text-right {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    .px-2 {
      width: 120px;
      margin-right: 1rem;
    }

    .button-group {
      display: flex;
      gap: 0.5rem;
      width: auto;
      min-width: 380px;

      .action-btn {
        flex: 1;
        white-space: nowrap;
        min-width: 120px;
        margin: 0 4px;
      }

      @media (max-width: 767px) {
        min-width: auto;
        width: 100px;
        flex-direction: column;
        
        .action-btn {
          min-width: auto;
        }
      }
    }

    @media (max-width: 767px) {
      .px-2 {
        width: auto;
        min-width: auto;
        margin-right: 0.5rem;
      }
    }
  }
}

.table-header {
  background: white;
  padding: 1rem;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.75rem;
  color: #666;

  .text-left {
    flex: 1;
    padding-left: 1rem;
  }

  .text-right {
    display: flex;
    align-items: center;

    .phone-number {
      width: 120px;
      margin-right: 3rem;
    }

    @media (max-width: 767px) {
      .phone-number {
        margin-right: 1rem;
      }
    }

    .actions-space {
      min-width: 380px;
      @media (max-width: 767px) {
        width: 100px;
        min-width: auto;
      }
    }
  }
}

.button-group {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 120px;
  padding: 8px 16px;
  font-size: 0.875rem;
  line-height: 1.125rem;
  border-radius: 3px;
  transition: all 0.2s ease-in-out;

  i {
    font-size: 0.875rem;
  }

  &:hover {
    opacity: 0.85;
  }

  &:focus {
    box-shadow: none !important;
  }
}
</style>
